import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { genId } from "@smartsheet/lodestar-utils";
import { useMemo } from "react";
export var internalOptionToString = function internalOptionToString(item) {
  if (item === null || item === undefined || isCreatableMarkerOption(item) || isSelectAllMarkerOption(item) || isSelectV2OptionSeparator(item)) {
    return "";
  } else if (Object.prototype.hasOwnProperty.call(item, "label")) {
    return item.label;
  } else {
    if (process.env.NODE_ENV !== "production") {
      console.warn("The options provided to the Select or MultiSelect component do not have a label" + " property. In this case, you must provide a the `optionToString` prop.", item);
    }
    return "";
  }
};
export var creatableMarkerOption = {
  value: "lodestar-select-createable-marker"
};
export var isCreatableMarkerOption = function isCreatableMarkerOption(option) {
  return option === creatableMarkerOption;
};
export var selectAllMarkerOption = {
  value: "lodestar-multiselect-select-all-marker"
};
export var isSelectAllMarkerOption = function isSelectAllMarkerOption(option) {
  return option === selectAllMarkerOption;
};
export var selectV2OptionSeparator = {
  value: "lodestar-select-separator-marker"
};
export var isSelectV2OptionSeparator = function isSelectV2OptionSeparator(option) {
  return option === selectV2OptionSeparator;
};

/**
 * We do this a lot in this component to make sure the container isn't handling
 * click events more than it should.
 */
export var stopPropagationHandler = function stopPropagationHandler(e) {
  e.stopPropagation();
  // Don't want to send the click up to the ClickAwayListener! We have to use the big hammer here
  // since ClickAwayListener adds event handlers at the document level and we want to make sure
  // they never get there since this event handler and the ones from ClickAwayListener are within
  // the same bubbling phase.
  e.nativeEvent.stopImmediatePropagation();
};
export var useSelectIds = function useSelectIds(type, providedId) {
  var idToUse = useMemo(function () {
    return providedId || genId("type");
  }, [providedId]);
  var sharedIdProps = {
    id: idToUse,
    menuId: idToUse + "--menu",
    toggleButtonId: idToUse + "--toggle-button"
  };
  return type === "select" ? sharedIdProps : _objectSpread(_objectSpread({}, sharedIdProps), {}, {
    inputId: idToUse
  });
};

// squashes all consecutive separators when options between them get
// filtered out, and removes leading and trailing separators.
export var squashSeparators = function squashSeparators(options) {
  var squashedOptions = [];
  var _iterator = _createForOfIteratorHelper(options.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        index = _step$value[0],
        option = _step$value[1];
      // escape early if we are adding a non-separator option
      if (!isSelectV2OptionSeparator(option)) {
        squashedOptions.push(option);
      } else {
        // only add non-consecutive separators
        var previousOption = options[index - 1];
        if (!isSelectV2OptionSeparator(previousOption) && !!previousOption) squashedOptions.push(option);
      }
    }
    // remove trailing separator after dealing with all consecutive options
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (isSelectV2OptionSeparator(squashedOptions[squashedOptions.length - 1])) squashedOptions.pop();
  return squashedOptions;
};

/**
 * Used to find the next valid option after a given index
 *
 * isDescending is used to indicate the direction we are indexing towards,
 * eg. either towards the bottom of the list or towards the top
 */
export var findNextValidOptionIndex = function findNextValidOptionIndex(options) {
  var startingIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isDescending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  for (var idx = startingIndex; options[idx]; idx += isDescending ? 1 : -1) {
    if (!isSelectV2OptionSeparator(options[idx])) return idx;
  }
  return undefined;
};
//# sourceMappingURL=utils.js.map